module.exports = __webpack_public_path__ + "img/xls.703f897d.png";